module.exports = __webpack_public_path__ + "img/MD.251451f4.svg";